import {useEffect, useState} from 'react'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useLoginCookie from 'shared/model/useLoginCookie'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetEventTemplate = (shouldFetch = false) => {
	const [result, setResult] = useState(null)
	const [, setAlert] = useAlertModalAtom()
	const [cookie] = useLoginCookie()
	const [userRole] = useRoleCookie()

	useEffect(() => {
		if (shouldFetch) {
			const downloadTemplate = async () => {
				try {
					const rolePath = getApiRolePath(userRole)
					let url = `/${rolePath}/seed-ticket/template`

					const response = await fetch(
						`${process.env.REACT_APP_BACKEND_URL}${url}`,
						{
							method: 'GET',
							headers: {
								token: cookie,
							},
						}
					)

					if (response.ok) {
						const blob = await response.blob()

						setResult({
							statusCode: 200,
							data: blob,
						})
					} else {
						setResult({
							statusCode: response.status,
							data: {message: '템플릿 다운로드에 실패했습니다.'},
						})
					}
				} catch (error) {
					setResult({
						statusCode: 500,
						data: {message: error.message},
					})
				}
			}

			downloadTemplate()
		}
	}, [shouldFetch, cookie])

	useEffect(() => {
		if (result?.statusCode && result?.statusCode !== 200) {
			setAlert(result?.data?.message || '템플릿 다운로드에 실패했습니다.')
		}
	}, [result])

	const resetResult = () => setResult(null)

	return [result, resetResult]
}

export default useGetEventTemplate
